var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRequests(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5jer9h8uga",
    d: "M12 2c5.527 0 10 4.473 10 10s-4.473 10-10 10c-1.629 0-3.222-.394-4.651-1.146l-.327-.18-4.001 1.288c-.282.09-.587.014-.792-.19-.181-.182-.26-.439-.217-.687l.026-.106 1.288-4.001C2.457 15.468 2 13.754 2 12 2 6.473 6.473 2 12 2zm0 1.563c-4.652 0-8.438 3.785-8.438 8.437 0 1.584.443 3.129 1.279 4.466.101.163.14.356.108.543l-.027.11-.93 2.89 2.888-.931c.223-.072.461-.04.654.081 1.337.836 2.882 1.279 4.466 1.279 4.652 0 8.438-3.786 8.438-8.438 0-4.652-3.786-8.438-8.438-8.438zM12 7c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm0 1.25c-2.071 0-3.75 1.679-3.75 3.75 0 2.071 1.679 3.75 3.75 3.75 2.071 0 3.75-1.679 3.75-3.75 0-2.071-1.679-3.75-3.75-3.75zm0 1.25c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -252.000000) translate(0.000000, 240.000000) translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3av73ayfjb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5jer9h8uga"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.87,
    mask: "url(#3av73ayfjb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequests);
export default __webpack_public_path__ + "static/media/icon-requests.1e651fb13416a431787d2e8289c63ba9.svg";
export { ForwardRef as ReactComponent };